import {Injectable, OnDestroy} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {IVersionDetails} from "../interfaces/version.details";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {LogCat, LogManager} from "../../log";
import {VersionDetailsProxy} from "./version.details.proxy";

@UntilDestroy()
@Injectable()
export class VersionDetailsService implements OnDestroy {

	readonly defaultVersion ="11.5.0.0";
	readonly defaultProductLabelingState = "RNMD";
	public subject: BehaviorSubject<IVersionDetails>;

	constructor(private versionDetailsProxy: VersionDetailsProxy) {
		this.subject = new BehaviorSubject<IVersionDetails>(null);
	}
	ngOnDestroy() { }

	public load() : Observable<IVersionDetails> {
		this.versionDetailsProxy.getVersionDetails()
			.pipe(untilDestroyed(this))
			.subscribe(result => {
				let versionDetails: IVersionDetails = {
					buildDate:   new Date(result.buildDate),
					commercialVersion: result.commercialVersion,
					internalVersion: result.internalVersion,
					productLabelingState: result.productLabelingState
				};
			this.subject.next(versionDetails);
		}, (e) => {
			LogManager.error(LogCat.AppShell.Login, "Failed to get server version details taking default values", e);

			//Take the current datetime
			let buildDate = new Date();

			let versionDetails: IVersionDetails = {
				buildDate: buildDate,
				commercialVersion: this.defaultVersion,
				internalVersion: this.defaultVersion,
				productLabelingState: this.defaultProductLabelingState
			};

			this.subject.next(versionDetails);
		});

		return this.subject.asObservable();
	}

	public getVersionDetails():IVersionDetails {
		return this.subject.getValue();
	}
}
